import React from 'react';
import content from '../data/content';
import LogoSvg from '../assets/Logo.svg';
import '../styles/Outlook.css';

function Outlook() {
  const { overview } = content;

  return (
    <section id="outlook" className="outlook-section">
      <div className="outlook-container">
        <h2>展望</h2>
        <div className="outlook-content-wrapper">
          <div className="outlook-text-content">
            <p>{overview.description}</p>
          </div>
          <div className="outlook-right-content">
            <img src={LogoSvg} alt="Project Logo" /> {/* ロゴを右カラムに移動 */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Outlook;